'use client';

import { useGetShopperTopMessageBar } from '@/common/apis/top-message-bar.api';
import {
  selectIsTenant,
  useDomainStore,
} from '@/store/use-domain.store';

export default function useTopMessageBar() {
  const isTenant = useDomainStore(selectIsTenant);
  const { data, isError } = useGetShopperTopMessageBar(isTenant);

  if (isError) {
    return { configuration: null };
  }

  return {
    configuration: data?.data?.message
      ? { ...data.data, isVisible: true }
      : null,
  };
}
